export const educationRegex = {
  universityNameRegex: /^[\p{L}0-9\s_\-'.’?|()/&]+$/u,
  specialtyNameRegex: /^[\p{L}0-9\s_\-'.’?|()/&]+$/u,
};
